var React = require('react');

function Hackernews (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2 0C0.895432 0 0 0.89543 0 2V22C0 23.1046 0.895432 24 2 24H22C23.1046 24 24 23.1046 24 22V2C24 0.895431 23.1046 0 22 0H2ZM13.3752 17.9373V13.4373L17.3775 5.93732H14.5527L12.1779 11.1627L9.69643 5.93732H6.75L10.875 13.4373V17.9373H13.3752Z","fill":"#495057"}));
}

Hackernews.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Hackernews;

Hackernews.default = Hackernews;
